import Component from './search.component'

export { default as SearchBarButton } from './components/searchbar-icon-button'
export default Component
